<template>
  <div class="minapp-popup" v-if="vvisible">
    <div class="clover"></div>
    <div class="container">
      <i class="close" @click="hide"></i>
      <a :href="href" target="_blank">
        <img src="./imgs/poster.png"/>
      </a>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
const KEY = 'minapp-popup-visible'
const cookieDomain = 
  location.hostname.includes('192.168') 
    ? location.hostname 
    : '.'+location.hostname.split('.').filter((_, index) => index > 0).join('.')


export default {
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: { type: Boolean, default: false },
  },
  data: () => ({
    vvisible: false,
    href: (location.host.includes('zhutui.cn') ? '//admin.zhutui.cn/' : `//${location.host}/`) + '#/extension/wxMiniProgram',

    time: null,
  }),

  watch: {
    visible: {
      // immediate: true,
      handler() {
        this.vvisible = this.visible
      },
    },
  },

  methods: {

    show() {
      const expires = new Date()
      expires.setHours(23, 59, 59)
      Cookies.set(KEY, '1', { domain: cookieDomain, expires })
      this.$emit('change', true)
      this.vvisible = true

      clearTimeout(this.time)
      this.time = setTimeout(() => {
        this.hide()
      }, 5000);
    },
    hide() {
      clearTimeout(this.time)
      this.$emit('change', false)
      this.vvisible = false
    },
  },

  mounted() {
    if (Cookies.get(KEY) !== '1') {
      setTimeout(() => {
        this.show()
      }, 1000);
    }
  },
}
</script>

<style lang="scss" scoped>
.minapp-popup {
  .clover {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(#000, .48);
  }
  .container {
    width: 672px;
    height: 504px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -336px;
    margin-top: -252px;
    img {
      width: 100%;
      object-fit: cover;
    }
  }
  .close {
    cursor: pointer;
    width: 24px;
    height: 24px;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    background: url('./imgs/ic_close.png') no-repeat center / contain;
  }
  position: relative;
  z-index: 1000000;
}
</style>